import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { authInterceptor, provideAuth } from 'angular-auth-oidc-client';

import { AUTH_CONFIG } from '@auth/consts/auth-config.const';
import { BROWSER_PROVIDERS } from '@core/consts/browser-providers.const';
import { CLARITY_PROVIDER } from '@core/consts/clarity-provider.const';
import { APOLLO_NAMED_PROVIDER } from '@graphql/shared/consts/apollo-named-provider.const';
import { MATERIAL_PROVIDERS } from '@shared/consts/material-providers.const';
import { loadingInterceptor } from '@shared/interceptors/loading.interceptor';

import { APP_ROUTES } from './routes/app.routes';

const interceptors = [authInterceptor(), loadingInterceptor];

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      APP_ROUTES,
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled' }),
      withComponentInputBinding(),
    ),
    CLARITY_PROVIDER,
    provideAnimationsAsync(),
    provideHttpClient(withFetch(), withInterceptors(interceptors)),
    provideAuth(AUTH_CONFIG),
    APOLLO_NAMED_PROVIDER,
    ...BROWSER_PROVIDERS,
    ...MATERIAL_PROVIDERS,
  ],
};
